export default __webpack_public_path__ + "static/media/articles.16a2ff41.svg";